var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnCheckDusk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5356 7.47495C18.8255 7.77073 18.8208 8.24558 18.5251 8.53555L9.85878 17.0319L5.49478 13.0543C5.18865 12.7753 5.16668 12.3009 5.4457 11.9948C5.72473 11.6886 6.1991 11.6667 6.50523 11.9457L9.82123 14.9681L17.475 7.46445C17.7707 7.17447 18.2456 7.17917 18.5356 7.47495Z",
    fill: "#B6B8D5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCheckDusk);
export default __webpack_public_path__ + "static/media/icn-check-dusk.aee4f07e313a943c98efc675d66161a0.svg";
export { ForwardRef as ReactComponent };